<template>
  <div class="root d-inline-block" v-if="hasAccess">
    <!-- <button v-if="mode === 'create'" class="btn btn-success" @click="btnClicked">{{ modalButtonName }}</button> -->
    <!-- <b-modal ref="modal" id="modal-center" class="accounting-modal" centered size="lg" :title="modalTitle" :ok-title="'ذخیره'" :hide-footer="mode === 'view'" :cancel-title="'لغو'" @ok="onModalOk"> -->
    <div class="row">
      <div class="col-3">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>تاریخ سند</span>
            </div>
          </div>
          <date-picker
            type="datetime"
            format="jYYYY-jMM-jDD HH:mm"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                v-model="accountingVoucherDate"
                class="form-control date-input"
                @focus="toggleDatePicker"
                @click="toggleDatePicker"
                readonly
              >
            </slot>
          </date-picker>
        </div>
      </div>
      <div class="col-2">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>پیوست</span>
            </div>
          </div>
          <input
            :disabled="mode === 'view'"
            v-model="doc.attachment"
            type="number"
            onkeydown="return event.keyCode !== 69"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-6">
        <div class="input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>شرح سند</span>
            </div>
          </div>
          <input
            :disabled="mode === 'view'"
            v-model="doc.description"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-1 d-flex justify-content-end">
        <button type="button" class="close" aria-label="Close" @click="goBack">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="ROW">
      <vs-table v-if="show" ref="table" :params="tableParams" :options="tableOptions"></vs-table>
    </div>
    <div class="row mb-2">
      <div class="col-12 d-flex justify-content-end">
        <div class="col-1">جمع</div>
        <div class="col-1 d-flex justify-content-center bg-danger radius p-1">
          <b>{{debtorSum}}</b>
        </div>
        <div class="col-1 ml-2 mr-5 d-flex justify-content-center bg-success radius p-1">
          <b>{{creditorSum}}</b>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="input-group mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام کل</span>
            </div>
          </div>
          <input
            :disabled="mode === 'view'"
            v-model="doc.total"
            ref="total"
            type="text"
            onkeydown="return event.keyCode !== 69"
            class="form-control"
            readonly
          >
        </div>
      </div>
      <div class="col-3">
        <div class="input-group mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام معین</span>
            </div>
          </div>
          <input
            :disabled="mode === 'view'"
            v-model="doc.moein"
            ref="moein"
            type="text"
            onkeydown="return event.keyCode !== 69"
            class="form-control"
            readonly
          >
        </div>
      </div>
      <div class="col-3">
        <div class="input-group mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>نام تفضیلی</span>
            </div>
          </div>
          <input
            :disabled="mode === 'view'"
            v-model="doc.tafzili"
            ref="tafzili"
            type="text"
            onkeydown="return event.keyCode !== 69"
            class="form-control"
            readonly
          >
        </div>
      </div>
      <div class="col-3">
        <div class="input-group mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>مانده حساب</span>
            </div>
          </div>
          <input
            :disabled="mode === 'view'"
            v-model="doc.accountRemain"
            ref="remaining"
            type="number"
            onkeydown="return event.keyCode !== 69"
            class="form-control"
            readonly
          >
        </div>
      </div>
    </div>
    <div class="row" v-if="mode!=='view'">
      <div class="col-8"></div>
      <div class="col-2">
        <button class="btn btn-info" @click="submitAndExit('continue')">تائید و ادامه</button>
      </div>
      <div class="col-2">
        <button class="btn btn-success" @click="submitAndExit('exit')">تائید و خروج</button>
      </div>
    </div>
    <!-- </b-modal> -->
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import BaseService from "../_framework/api/BaseService.js";
import Utils from "../_framework/utils/Utils.js";
import VsSelect from "../_framework/VsSelect";
import VsTableMixin from "../_framework/VsTableMixin.js";
import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
import AccountTitleSelect from "../components/AccountTitleSelect.vue";
import Debtor from "../components/Debtor.vue";
import Creditor from "../components/Creditor.vue";
import EventBus from "../_framework/bus.js";
import * as $ from "jquery";
import Moment from "moment-jalali";
import accounting from "accounting";
import Vue from "vue";
export default {
  name: "accounting-documents-modal-button",
  props: {
    data: {},
    params: {
      mode: "view"
    },
    entityDisplayName: {
      default: "سند حسابداری",
      type: String
    }
  },
  mixins: [VsTableMixin],
  components: {
    VsSelect,
    datePicker: DatePicker,
    AccountTitleSelect,
    Debtor,
    Creditor,
    Moment
  },
  data() {
    return {
      mode: "",
      access: {},
      entity: "AccountingVouchers",
      debtorSum: 0,
      creditorSum: 0,
      model: {},
      accountTitlesList: [],
      show: true,
      accountingVoucherDate: null,
      journals: null,
      doc: {
        id: 0,
        number: "",
        documentId: "",
        date: "",
        attachment: "",
        description: "",
        total: "",
        moein: "",
        tafzili: "",
        remaining: "",
        journals: [],
        accountRemain: 0
      },
      tableParams: {
        entity: "accountingdocument",
        list: [],
        headers: {
          id: {
            title: "ردیف",
            type: "number",
            grow: 0.18,
            isSearchable: false,
            inHeader: false,
            rowAlignment: "center",
            mode: "view",
            flex: 1
          },
          accountCode: {
            title: "کد حساب",
            type: "custom",
            component: AccountTitleSelect,
            grow: 1.7,
            flex: 1,
            rowAlignment: "center"
          },
          description: {
            title: "شرح",
            type: "text",
            rowAlignment: "center",
            grow: 2,
            flex: 1
          },
          debtor: {
            title: "بدهکار",
            type: "custom",
            component: Debtor,
            rowAlignment: "center",
            grow: 0.7
          },
          creditor: {
            title: "بستانکار",
            type: "custom",
            component: Creditor,
            rowAlignment: "center",
            grow: 0.7
          }
        }
      },
      tableOptions: {
        tableHeight: "18rem",
        headerActionsMode: "create",
        deleteEntityAction: "reset",
        dataSourceType: "store",
        hasActions: true,
        onRowClicked: row => {
          this.setAccountTitleDetail(this.getAncestors(row.accountTitleId));
        },
        hasActionsInHeader: true,
        clickableRows: true,
        beforeCreateEntity: input => {
          if (!this.valid(input)) {
            return;
          }
          this.insertRow(input);
          return;
        },
        beforeUpdateEntity: input => {
          if (!this.valid(input)) {
            return;
          }
          this.updateRow(input);
          return input;
        },
        beforeDeleteEntity: input => {
          this.deleteFromJournals(input.id);
          return input;
        },
        onRowDoubleClicked: row => {
          // console.log(row);
        }
      }
    };
  },

  methods: {
    valid(data) {
      if (!data.accountCode) {
        this.$noty.error("کد حساب را انتخاب نمایید");
        return false;
      }
      if (!(data.debtor > 0 || data.creditor > 0)) {
        this.$noty.error("یک مبلغ را به عنوان بدهکار یا بستانکار وارد نمائید");
        return false;
      }
      return true;
    },
    setAccountTitleDetail(data) {
      if (this.$refs.total) {
        this.$refs.total.value =
          data && data.ancestors
            ? data.ancestors[1].code + " " + data.ancestors[1].title
            : "";
      }
      if (this.$refs.moein) {
        this.$refs.moein.value =
          data && data.ancestors
            ? data.ancestors[0].code + " " + data.ancestors[0].title
            : "";
      }
      if (this.$refs.tafzili) {
        this.$refs.tafzili.value = data ? data.title : "";
      }
      if (data && data.code) {
        new BaseService("AccountTitle/GetRemain")
          .getById(data.code)
          .then(rs => {
            if (this.$refs && this.$refs.remaining) {
              this.$refs.remaining.value = rs.data.remain;
            }
          });
      }
    },
    findById(id, data) {
      let item = data.find(d => {
        return d.id === id;
      });
      return item;
    },
    getAncestors(id) {
      let data = this.accountTitlesList;
      let item = this.findById(id, data);
      let pId = item.parentId;
      let ancestors = [];
      while (pId) {
        let node = this.findById(pId, data);
        ancestors.push(node);
        pId = node.parentId;
      }
      item.ancestors = ancestors;
      return item;
    },
    insertRow(data) {
      this.doc.journals.push({
        accountTitleId: data.accountCode.id,
        accountTitleCode: data.accountCode.code,
        accountCode: data.accountCode.title,
        description: data.description,
        debtor: data.debtor * 1,
        creditor: data.creditor * 1
      });
      this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
        accountTitleId: data.accountCode.id,
        accountTitleCode: data.accountCode.code,
        accountCode: data.accountCode.code,
        description: data.description,
        debtor: accounting.formatNumber(data.debtor * 1),
        creditor: accounting.formatNumber(data.creditor * 1)
      });
      $(".dropdown input.form-control").focus();
      EventBus.$emit("onResetHeaderFormsValue");
      this.refreshTable();
    },
    updateRow(data) {
      this.doc.journals = this.doc.journals.map(j => {
        if (j.id === data.id) {
          j.accountTitleId = data.accountCode.id;
          j.accountTitleCode = data.accountCode.code;
          j.accountCode = data.accountCode.title;
          j.description = data.description;
          j.debtor = data.debtor * 1;
          j.creditor = data.creditor * 1;
        }
        return j;
      });
      let list = this.vsTableFeed;
      list = list.map(j => {
        if (j.id === data.id) {
          j.accountTitleId = data.accountCode.id || data.accountTitleId;
          j.accountTitleCode = data.accountCode.code || data.accountTitleCode;
          j.accountCode = data.accountCode.title || data.accountTitleCode;
          j.description = data.description;
          j.debtor = data.debtor * 1;
          j.creditor = data.creditor * 1;
        }
        return j;
      });
      this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
      this.show = false;
      setTimeout(() => {
        this.$store.commit("RESET_VS_TABLE_FEED", list);
        this.refreshTable();
        this.show = true;
      }, 5);
    },
    refreshTable() {
      let id = 0;
      this.doc.remaining = 0;
      this.debtorSum = this.creditorSum = 0;
      let debtorSum = 0;
      let creditorSum = 0;
      this.vsTableFeed.map(p => {
        id = id + 1;
        p.id = id;
      });
      id = 0;
      this.doc.journals.map(p => {
        id = id + 1;
        p.id = id;
        this.doc.remaining = this.doc.remaining + p.debtor * 1 - p.creditor * 1;
        debtorSum = debtorSum + p.debtor * 1;
        creditorSum = creditorSum + p.creditor * 1;
      });
      this.debtorSum = accounting.formatNumber(debtorSum);
      this.creditorSum = accounting.formatNumber(creditorSum);
      // if (this.$refs.remaining) {
      //   this.$refs.remaining.value = this.doc.remaining;
      // }
    },
    deleteFromJournals(id) {
      this.doc.journals = this.doc.journals.filter(j => {
        return j.id !== id;
      });
    },
    submitAndExit(nextAction) {
      if (!this.vsTableFeed.length) {
        Utils.handleErrorWithNotification(
          "هیچ سرفصل حسابی وارد نشده است",
          this.$noty
        );
        return;
      }
      if (this.doc.remaining !== 0) {
        Utils.handleErrorWithNotification(
          "جمع ستون های بستانکار و بدهکار باید برابر باشد",
          this.$noty
        );
        return;
      }
      if (nextAction === "exit") {
        this.onCreate(this.goBack);
      } else {
        this.onCreate(this.resetForm);
      }
    },
    setForm(data) {
      this.doc = data;
      data.journals.map(d => {
        this.insertRow({
          accountCode: d.accountTitle,
          description: d.description,
          debtor: d.debtor,
          creditor: d.creditor
        });
      });
      this.doc.journals = this.doc.journals.filter(j => {
        return !j.accountTitle;
      });
    },
    resetForm() {
      this.doc = {};
      this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
    },
    goBack() {
      this.$router.push({ name: "اسناد حسابداری" });
    },
    setDateFromDatePicker(date) {
      this.doc.date = date;
      this.accountingVoucherDate = this.formatDateTime(date);
    },
    formatDateTime(date) {
      return (
        date.substring(0, 4) +
        "/" +
        date.substring(5, 7) +
        "/" +
        date.substring(8, 10) +
        "-" +
        date.substring(11, 16)
      );
    },
    toggleDatePicker() {
      if (this.mode === "view") {
        return;
      }
      this.$refs.datePicker.togglePicker();
    },
    btnClicked() {
      this.$refs.modal.show();
      this.calculatePrependWidth();
    },
    onModalOk(e) {
      e.preventDefault();
      if (this.mode === "create") {
        this.onCreate();
      } else if (this.mode === "edit") {
        this.onUpdate();
      }
    },
    onCreate(callBack) {
      // if (this.doc.date) {
      //   let date = Moment(this.doc.date, "jYYYY/jMM/jDD HH:mm");
      //   this.doc.date = date.format("YYYY/MM/DD HH:mm");
      // }
      if (this.mode === "edit") {
        new BaseService(this.entity)
          .update({
            id: this.doc.id,
            attachment: this.doc.attachment,
            date: this.doc.date,
            description: this.doc.description,
            journals: this.doc.journals
          })
          .then(response => {
            this.$noty.success("موفقیت آمیز.");
            callBack && callBack();
          });
        // .catch(error => {
        //   // error
        //   Utils.handleErrorWithNotification(error.data.message, this.$noty);
        // });
      } else {
        new BaseService(this.entity)
          .create({
            attachment: this.doc.attachment,
            date: this.doc.date,
            description: this.doc.description,
            journals: this.doc.journals
          })
          .then(response => {
            this.$noty.success("موفقیت آمیز.");
            callBack && callBack();
          });
        // .catch(error => {
        //   console.log(error);

        //   // error
        //   Utils.handleErrorWithNotification(
        //     (error.data && error.data.message) || "داده ها ناقص است",
        //     this.$noty
        //   );
        // });
      }
    },
    onUpdate() {
      new BaseService("services").update(this.service).then(response => {
        this.$noty.success("موفقیت آمیز.");
        this.$refs.modal.hide();
        this.$emit("onFetchList");
      });
      // .catch(error => {
      //   // error
      //   Utils.handleErrorWithNotification(error.data.message, this.$noty);
      // });
    },
    resetModel() {
      Utils.resetObject(this.service);
      this.service.id = 0;
    }
  },
  computed: {
    ...mapState([
      "selectedRows",
      "currentService",
      "vsTableFeed",
      "tableRowIndex"
    ]),
    modalButtonName() {
      return (
        (this.mode === "create" ? "ایجاد" : "ویرایش") +
        " " +
        this.entityDisplayName +
        " "
      );
    },
    modalTitle() {
      switch (this.mode) {
        case "view":
          return "مشاهده جزییات " + this.entityDisplayName;
        case "create":
          return "ایجاد " + this.entityDisplayName;
        case "edit":
          return "ویرایش " + this.entityDisplayName;
        default:
          return "";
      }
    }
  },
  created() {},
  beforeMount() {
    this.tableOptions.access = checkAccess(this.$route.path);
    this.hasAccess = this.tableOptions.access ? true : false;
  },
  mounted() {
    this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
    this.mode = this.$route.query._mode;
    if (this.$route.query._mode === "view") {
      this.tableOptions.hasActions = false;
      this.tableOptions.hasActionsInHeader = false;
    }
    if (this.$route.query.id) {
      new BaseService("AccountingVouchers")
        .getById(this.$route.query.id)
        .then(rs => {
          this.accountingVoucherDate = this.formatDateTime(rs.data.date);
          this.setForm(rs.data);
        });
    }

    let flag = true;
    EventBus.$on("onPressEnter", () => {
      if (flag) {
        try {
          let data = this.$refs.table.getHeaderFormsInput();
          this.insertRow(data);
          flag = false;
          EventBus.$emit("onResetHeaderFormsValue");
          setTimeout(() => {
            $(".dropdown input.form-control").focus();
            flag = true;
          }, 50);
        } catch (error) {}
      }
    });
    EventBus.$on("onSelectAccountTitle", data => {
      if (data) {
        this.setAccountTitleDetail(data);
        let inputs = $(document).find("input");
        inputs.map(i => {
          if (inputs[i].placeholder === "شرح را وارد کنید") {
            inputs[i].focus();
          }
        });
      }
    });
    new BaseService("accounttitle").getAll().then(rs => {
      this.accountTitlesList = rs.data;
    });
  },
  watch: {
    vsTableFeed: {
      handler(val) {
        this.refreshTable();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
hr {
  background-color: rgba(255, 255, 255, 0.4);
}

.input-group > div:not(.custom) {
  display: flex;
  flex: 1;
}
.radius {
  border-radius: 0.5rem;
}
</style>
